import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useSubmit } from 'react-router-dom';
import { Avatar } from '@scholastic/mockingjay';
import { useGetMeApi } from 'eds-common/api/v2';
import ProfileAvatarPlaceholder from '@/assets/icons/profile-avatar-placeholder.svg';

const TRIGGER_CLASSES =
  'flex h-11 w-11 items-center justify-center rounded-full bg-brand-white shadow-md focus-ring hover:bg-neutral-100';

const AVATAR_CLASSES = 'h-11 w-11 bg-neutral-100 uppercase';

export function StudentProfileMenu() {
  const { data: user } = useGetMeApi();
  const submit = useSubmit();

  const isClassroomPassword =
    user?.currentRole === 'student' && user?.userSource === 'MyScholastic';

  const onSignOut = () => {
    submit(null, { method: 'post', action: '/sign-out' });
  };

  const avatar = isClassroomPassword ? (
    <ProfileAvatarPlaceholder aria-hidden className="h-11 w-11" />
  ) : (
    user?.givenName &&
    user?.familyName && (
      <Avatar
        aria-hidden
        name={`${user.givenName} ${user.familyName}`}
        variant="medium"
        className={AVATAR_CLASSES}
      />
    )
  );

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button type="button" className={TRIGGER_CLASSES} aria-label="Profile">
          {avatar}
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className="space-y-4 overflow-hidden rounded-lg bg-white py-5 shadow-[0_4px_24px_0_rgba(0,0,0,0.25)]"
          align="end"
        >
          <div className="flex items-center gap-2 px-5">
            {avatar}
            {user && (
              <div className="max-w-[240px] bg-brand-white">
                <p className="truncate font-semibold capitalize text-neutral-1300">
                  {isClassroomPassword
                    ? `${user.givenName} Classroom`
                    : `${user.givenName} ${user.familyName}`}
                </p>
                {!isClassroomPassword && (
                  <p className="truncate text-sm capitalize text-neutral-900">
                    {user.currentRole}
                  </p>
                )}
              </div>
            )}
          </div>

          <DropdownMenu.Item
            className="cursor-pointer px-5 py-2 text-lg font-light leading-[18px] outline-none data-[highlighted]:bg-neutral-1100 data-[highlighted]:font-normal data-[highlighted]:text-brand-white"
            onSelect={onSignOut}
          >
            Sign Out
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
